import { CALL_API } from 'redux-api-middleware';
import endpoints from 'api/endpoints';
import types from '../types';

export default data => ({
  [CALL_API]: {
    endpoint: endpoints.ORDERS_API,
    method: 'POST',
    body: JSON.stringify(data),

    headers: {
      'Content-Type': 'application/json',
    },

    types: [
      types.POST_ORDER_REQUEST,

      types.POST_ORDER_SUCCESS,

      types.POST_ORDER_FAILURE,
    ],
  },
});



// WEBPACK FOOTER //
// ./src/api/orders/actions/postOrder.js